import { api } from './api';

export type GoalMode = 'off' | 'shadow' | 'live';

export interface GoalModeEntry {
  goalId: string;
  pack: string;
  when: string;
  mode: GoalMode;
  killed: boolean;
}

export interface GoalModesView {
  sessionId: string;
  enabled: boolean;
  goals: GoalModeEntry[];
}

export const goalModesService = {
  async get(sessionId: string): Promise<GoalModesView> {
    const res = await api.get(`/api/sessions/${sessionId}/goal-modes`);
    return res.data;
  },

  async set(sessionId: string, goalId: string, mode: GoalMode): Promise<GoalModesView> {
    const res = await api.put(`/api/sessions/${sessionId}/goal-modes`, { goalId, mode });
    return res.data;
  },
};
